export const DRAW = 'draw' // 抽獎
export const AUCTION = 'auction' // 拍賣
export const BIDDING = 'bidding' // 喊單模組
